import {useEffect} from 'react';
import '../styles/TechologiesPage.scss';
import {Row, Col} from 'react-simple-flex-grid';
import metaHumanSectionBg from "../images/metahuman_section_bg.png";
import {Chip} from "./Chip";
import voiceover_promo_video from "../video/voiceover_promo.mp4";
import {ArtificialIntelligence} from "./ArtificialIntelligence";
import {TechnologiesCloud} from "./TechnologiesCloud";
import {TechnologiesMore} from "./TechnologiesMore";
import {useInView} from "react-intersection-observer";


function Technologies(props: { title: string }) {
    const metaHumanChipsList = ['Automotive', 'Retail', 'Fashion', 'e-learning', 'entertainment & gaming', 'broadcasting']

    useEffect(() => {
        document.title = props.title;
    });

    const scrollToSection = () => {
        const navbarHeight = 100;

        const targetElement = document.querySelector('.meta-human-section') as HTMLElement;

        if (targetElement) {
            const targetPosition = targetElement.offsetTop - navbarHeight;

            window.scrollTo({
                top: targetPosition,
                behavior: 'smooth'
            });
        }
    }

    const [technologiesSectionRef, technologiesSectionRefInView] = useInView({
        triggerOnce: true,
        threshold: 0.2
    });

    const [metaHumanSectionRef, metaHumanSectionRefInView] = useInView({
        triggerOnce: true,
        threshold: 0.4
    });

    const [voiceoverSectionRef, voiceoverSectionRefInView] = useInView({
        triggerOnce: true,
        threshold: 0.4
    });

    const [artificialSectionRef, artificialSectionRefInView] = useInView({
        triggerOnce: true,
        threshold: 0.4
    });

    const [technologiesCloudSectionRef, technologiesCloudSectionRefInView] = useInView({
        triggerOnce: true,
        threshold: 0.4
    });

    const [technologiesMoreSectionRef, technologiesMoreSectionRefInView] = useInView({
        triggerOnce: true,
        threshold: 0.4
    })


    return (
        <div className="technologies-page-wrapper">
            <div ref={technologiesSectionRef}
                 className={technologiesSectionRefInView ? 'technologies-section slideInUp' : 'technologies-section'}>
                <Row align="stretch">
                    <Col xs={12} sm={{span: 4, offset: 4}} xl={{span: 2.5, offset: 4}}>
                        <h1>technologies</h1>
                        <h1 className="semi-transparent">from the future</h1>
                    </Col>
                    <Col xs={12} sm={{span: 10, offset: 1}} xl={{span: 8, offset: 2}}>
                        <p>
                            Know Your Future with Alnair Fortune Teller solution was created for WebSummit to emphasize
                            our experience with the cutting-edge technologies combined with matured ones. In this
                            solution we used pretty extensive list of technologies and tools
                        </p>
                    </Col>
                    <Col xs={{span: 4, offset: 4}} xl={{span: 4, offset: 4}} className="discover-more-container"
                         onClick={scrollToSection}>
                        <div className="discover-more">
                            <span className="discover-title">Discover</span>
                            <svg xmlns="http://www.w3.org/2000/svg" width="30" height="14" viewBox="0 0 30 14"
                                 fill="none">
                                <path d="M2 2L15.65 11L28 2" stroke="white" strokeWidth="4"/>
                            </svg>
                        </div>
                    </Col>
                </Row>
                <div className="section-shadow section-shadow-from-bottom"></div>
            </div>
            <div ref={metaHumanSectionRef}
                 className={metaHumanSectionRefInView ? 'meta-human-section slideInUp' : 'meta-human-section'}>
                <div className="section-shadow section-shadow-from-top"></div>
                <Row>
                    <Col xs={10} sm={6}>
                        <h3 className="section-title">
                            meta human
                        </h3>
                        <h5 className="section-subtitle">
                            MetaHuman Creator + <br className="mobile"/> Blender + <br className="desktop"/>Pinch of
                            magic
                        </h5>
                    </Col>
                </Row>
                <Row>
                    <Col span={12}>
                        <img src={metaHumanSectionBg} alt="section background"/>
                    </Col>
                </Row>
                <Row gutter={60}>
                    <Col xs={12} sm={6}>
                        <p className="footer-description">
                            To create the character of Alnair we used MetaHuman Creator by Epic Games along with some
                            other applications such as Blender used for body and clothing animation, textures
                            adjustments and applications for digital clothing design and 'sewing'.
                        </p>
                    </Col>
                    <Col xs={12} sm={6}>
                        <h5 className="meta-human-chips-title">applicable to</h5>
                        <div className="chips-container small-chips">
                            {metaHumanChipsList.length && metaHumanChipsList.map((item: string, index) => {
                                return <Chip key={index} chip={item}/>
                            })}
                        </div>
                    </Col>
                </Row>
                <div className="section-shadow section-shadow-from-bottom"></div>
            </div>
            <div ref={voiceoverSectionRef}
                 className={voiceoverSectionRefInView ? 'voiceover-section slideInUp' : 'voiceover-section'}>
                <div className="section-shadow section-shadow-from-top"></div>
                <Row>
                    <Col span={12}>
                        <div className="voiceover-video-wrapper">
                            <video
                                className="voiceover-video"
                                autoPlay
                                playsInline
                                muted
                                loop
                            >
                                <source src={voiceover_promo_video} type="video/mp4"/>
                            </video>
                            <div className="voiceover-video-description">
                                <h5 className="voiceover-video-title">voiceover</h5>
                                <p className="voiceover-video-subtitle">To make a voiceover and mimics for Alnair, we
                                    used
                                    MetaHuman Animator by Epic Games. The application captured it from the real actor
                                    and
                                    applied to the Metahuman Alnair.</p>
                            </div>
                        </div>
                    </Col>
                </Row>
                <div className="section-shadow section-shadow-from-bottom"></div>
            </div>
            <div ref={artificialSectionRef}
                 className={artificialSectionRefInView ? 'artificial-section slideInUp' : 'artificial-section'}>
                <div className="section-shadow section-shadow-from-top"></div>
                <ArtificialIntelligence/>
                <div className="section-shadow section-shadow-from-bottom"></div>
            </div>
            <div ref={technologiesCloudSectionRef}
                 className={technologiesCloudSectionRefInView ? 'technologies-cloud-section slideInUp' : 'technologies-cloud-section'}>
                <div className="section-shadow section-shadow-from-top"></div>
                <TechnologiesCloud/>
                <div className="section-shadow section-shadow-from-bottom"></div>
            </div>
            <div ref={technologiesMoreSectionRef}
                 className={technologiesMoreSectionRefInView ? 'technologies-more-section slideInUp' : 'technologies-more-section'}>
                <div className="section-shadow section-shadow-from-top"></div>
                <TechnologiesMore/>
                <div className="section-shadow section-shadow-from-bottom"></div>
            </div>
        </div>
    );
}

export default Technologies;